import React, { Fragment } from 'react'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { HACIENDA_PARSING_ERROR } from '../../../../../utils/exceptions/constants'
import CircularProgress from '../../../../../components/CircularProgress'
import { ReactComponent as UploadIcon } from '../../../../../components/Icons/upload-icon.svg'
import TickIcon from './TickIcon'
import FormUploadButton from './FormUploadButton'
import FileField from '../../../../../components/FormFields/FileField/FileField'

import { ReactComponent as PreIcon } from '../../../../../components/Icons/file-text.svg'
import { ReactComponent as SearchIcon } from '../../../../../components/Icons/search-icon.svg'
import UploadForm from './UploadForm'
import { callAll, hasUploadError, renderUploadError } from './utils'

import messages from '../../../../../utils/exceptions/messages'

function UploadFileField({
  id,
  values,
  errors,
  touched,
  status = {},
  success,
  handleSubmit,
  setFieldValue,
  handleBlur,
  isSubmitting,
  submitError,
  onChangeInput,
  hasParsingError,
  ...props
}) {
  const parsingErrorText = <FormattedMessage
    {...messages[HACIENDA_PARSING_ERROR]}
  />
  const suffix = isSubmitting
    ? <CircularProgress size={20} />
    : success || status.success
      ? <TickIcon />
      : (
        <Fragment>
          <FormUploadButton
            as='label'
            htmlFor={id}
          >
            Seleccionar <SearchIcon />
          </FormUploadButton>
          <FormUploadButton type='submit'>
            Subir <UploadIcon />
          </FormUploadButton>
        </Fragment>
      )
  return (
    <UploadForm onSubmit={handleSubmit}>
      <FileField
        {...props}
        name='files'
        id={id}
        value={values.files}
        disabled={success || status.success}
        onChange={callAll(event => {
          setFieldValue('files', event.target.files[0])
        }, onChangeInput)}
        onBlur={handleBlur}
        prefix={
          <label htmlFor={id}>
            <PreIcon width='20px' />
          </label>
        }
        suffix={suffix}
        error={hasParsingError || hasUploadError('files', { errors, touched, status, submitError })}
        help={hasParsingError ? parsingErrorText : renderUploadError('files', { errors, touched, status, submitError })}
        {...props}
      />
    </UploadForm>
  )
}

export default UploadFileField
